"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.US_STATES_BY_CODE = exports.US_STATE_CODES = exports.US_STATES = void 0;
exports.isValidStateCode = isValidStateCode;
/** D-27: 50 states + DC + 5 territories + 3 AFPO = 59 条,按 code 字母升序。
 *  数据源:USPS 官方 https://pe.usps.com/text/pub28/28apb.htm */
exports.US_STATES = [
    { code: 'AA', name: 'Armed Forces Americas', category: 'afpo' },
    { code: 'AE', name: 'Armed Forces Europe', category: 'afpo' },
    { code: 'AK', name: 'Alaska', category: 'state' },
    { code: 'AL', name: 'Alabama', category: 'state' },
    { code: 'AP', name: 'Armed Forces Pacific', category: 'afpo' },
    { code: 'AR', name: 'Arkansas', category: 'state' },
    { code: 'AS', name: 'American Samoa', category: 'territory' },
    { code: 'AZ', name: 'Arizona', category: 'state' },
    { code: 'CA', name: 'California', category: 'state' },
    { code: 'CO', name: 'Colorado', category: 'state' },
    { code: 'CT', name: 'Connecticut', category: 'state' },
    { code: 'DC', name: 'District of Columbia', category: 'dc' },
    { code: 'DE', name: 'Delaware', category: 'state' },
    { code: 'FL', name: 'Florida', category: 'state' },
    { code: 'GA', name: 'Georgia', category: 'state' },
    { code: 'GU', name: 'Guam', category: 'territory' },
    { code: 'HI', name: 'Hawaii', category: 'state' },
    { code: 'IA', name: 'Iowa', category: 'state' },
    { code: 'ID', name: 'Idaho', category: 'state' },
    { code: 'IL', name: 'Illinois', category: 'state' },
    { code: 'IN', name: 'Indiana', category: 'state' },
    { code: 'KS', name: 'Kansas', category: 'state' },
    { code: 'KY', name: 'Kentucky', category: 'state' },
    { code: 'LA', name: 'Louisiana', category: 'state' },
    { code: 'MA', name: 'Massachusetts', category: 'state' },
    { code: 'MD', name: 'Maryland', category: 'state' },
    { code: 'ME', name: 'Maine', category: 'state' },
    { code: 'MI', name: 'Michigan', category: 'state' },
    { code: 'MN', name: 'Minnesota', category: 'state' },
    { code: 'MO', name: 'Missouri', category: 'state' },
    { code: 'MP', name: 'Northern Mariana Islands', category: 'territory' },
    { code: 'MS', name: 'Mississippi', category: 'state' },
    { code: 'MT', name: 'Montana', category: 'state' },
    { code: 'NC', name: 'North Carolina', category: 'state' },
    { code: 'ND', name: 'North Dakota', category: 'state' },
    { code: 'NE', name: 'Nebraska', category: 'state' },
    { code: 'NH', name: 'New Hampshire', category: 'state' },
    { code: 'NJ', name: 'New Jersey', category: 'state' },
    { code: 'NM', name: 'New Mexico', category: 'state' },
    { code: 'NV', name: 'Nevada', category: 'state' },
    { code: 'NY', name: 'New York', category: 'state' },
    { code: 'OH', name: 'Ohio', category: 'state' },
    { code: 'OK', name: 'Oklahoma', category: 'state' },
    { code: 'OR', name: 'Oregon', category: 'state' },
    { code: 'PA', name: 'Pennsylvania', category: 'state' },
    { code: 'PR', name: 'Puerto Rico', category: 'territory' },
    { code: 'RI', name: 'Rhode Island', category: 'state' },
    { code: 'SC', name: 'South Carolina', category: 'state' },
    { code: 'SD', name: 'South Dakota', category: 'state' },
    { code: 'TN', name: 'Tennessee', category: 'state' },
    { code: 'TX', name: 'Texas', category: 'state' },
    { code: 'UT', name: 'Utah', category: 'state' },
    { code: 'VA', name: 'Virginia', category: 'state' },
    { code: 'VI', name: 'U.S. Virgin Islands', category: 'territory' },
    { code: 'VT', name: 'Vermont', category: 'state' },
    { code: 'WA', name: 'Washington', category: 'state' },
    { code: 'WI', name: 'Wisconsin', category: 'state' },
    { code: 'WV', name: 'West Virginia', category: 'state' },
    { code: 'WY', name: 'Wyoming', category: 'state' },
];
exports.US_STATE_CODES = exports.US_STATES.map((s) => s.code);
exports.US_STATES_BY_CODE = Object.fromEntries(exports.US_STATES.map((s) => [s.code, s]));
/** D-07: 后端必须用此函数校验 state 码,防止前端绕过 */
function isValidStateCode(code) {
    return exports.US_STATE_CODES.includes(code);
}
